import { Controller } from "@hotwired/stimulus"
import { deleteCookie, readCookie, writeCookie } from "../../lib/cookies"

export default class extends Controller {
  static values = { cookieName: String, mobile: Boolean }

  connect() {
    this.element.dataset.saleMenuReady = "true"
  }

  disconnect() {
    window.clearTimeout(this.loaderTimeout)
    delete this.element.dataset.saleMenuReady
  }

  toggle(event) {
    const button = event.currentTarget
    const item = button.closest("li")
    const categoryId = button.dataset.category
    const categories = readCookie(this.cookieNameValue).split(",").filter(Boolean)
    const categoryIndex = categories.indexOf(categoryId)

    item.classList.toggle("closed")
    button.setAttribute("aria-expanded", String(!item.classList.contains("closed")))

    if (categoryIndex === -1) {
      categories.push(categoryId)
    } else {
      categories.splice(categoryIndex, 1)
    }

    if (categories.length) {
      writeCookie(this.cookieNameValue, categories.join(","), 1)
    } else {
      deleteCookie(this.cookieNameValue)
    }

  }

  navigate(event) {
    if (!this.mobileValue || !event.target.closest("a")) return

    const loader = document.getElementById("ui-loader")
    loader?.classList.add("active")
    window.clearTimeout(this.loaderTimeout)
    this.loaderTimeout = window.setTimeout(() => loader?.classList.remove("active"), 100)
  }

}
